import { isTestEnv } from '../../../utils/env/isTestEnv';

export const InspireCardSkeletonTestId = isTestEnv() ? 'InspireCardSkeleton_TEST-ID' : undefined;
